/**
 * Owner: Masa Bayu
 * File: qx-taxonomy-data-b.ts
 * Date:Time: 2026-10-19 11:40
 * Description: §405 — data taksonomi QX bahagian B (kategori 19–36: Children
 *   and Young Adult hingga Alamtologi).
 */
export const QX_TAXONOMY_DATA_B = Object.freeze([
    Object.freeze({
        id: 'children-ya',
        en: 'Children and Young Adult',
        ms: 'Kanak-Kanak dan Remaja',
        subcategories: Object.freeze([
            { id: 'children-ya.baby-and-preschool', en: 'Baby and Preschool Books', ms: 'Buku Bayi dan Prasekolah' },
            { id: 'children-ya.picture-books', en: 'Picture Books', ms: 'Buku Bergambar' },
            { id: 'children-ya.childrens-stories', en: "Children's Stories", ms: 'Cerita Kanak-Kanak' },
            { id: 'children-ya.early-learning-books', en: 'Early Learning Books', ms: 'Buku Pembelajaran Awal' },
            { id: 'children-ya.activity-books', en: 'Activity Books', ms: 'Buku Aktiviti' },
            { id: 'children-ya.childrens-fiction', en: "Children's Fiction", ms: 'Fiksyen Kanak-Kanak' },
            { id: 'children-ya.ya-novels', en: 'Young Adult Novels', ms: 'Novel Remaja' },
            { id: 'children-ya.ya-science-fiction', en: 'Young Adult Science Fiction', ms: 'Fiksyen Saintifik Remaja' },
            { id: 'children-ya.ya-fantasy', en: 'Young Adult Fantasy', ms: 'Fantasi Remaja' },
            { id: 'children-ya.social-emotional-learning', en: 'Social and Emotional Learning', ms: 'Pembelajaran Sosial dan Emosi' },
            { id: 'children-ya.childrens-comics', en: "Children's Comics", ms: 'Komik Kanak-Kanak' },
            { id: 'children-ya.general-knowledge-books', en: 'General Knowledge Books', ms: 'Buku Pengetahuan Umum' },
        ]),
    }),
    Object.freeze({
        id: 'biography',
        en: 'Biography and Memoir',
        ms: 'Biografi dan Memoir',
        subcategories: Object.freeze([
            { id: 'biography.biography', en: 'Biography', ms: 'Biografi' },
            { id: 'biography.autobiography', en: 'Autobiography', ms: 'Autobiografi' },
            { id: 'biography.memoir', en: 'Memoir', ms: 'Memoir' },
            { id: 'biography.historical-figures', en: 'Historical Figures', ms: 'Tokoh Sejarah' },
            { id: 'biography.scientists-biographies', en: "Scientists' Biographies", ms: 'Biografi Saintis' },
            { id: 'biography.leaders-biographies', en: "Leaders' Biographies", ms: 'Biografi Pemimpin' },
            { id: 'biography.entrepreneurs-biographies', en: "Entrepreneurs' Biographies", ms: 'Biografi Usahawan' },
            { id: 'biography.life-stories', en: 'Life Stories', ms: 'Kisah Kehidupan' },
            { id: 'biography.family-history', en: 'Family History', ms: 'Sejarah Keluarga' },
            { id: 'biography.inspirational-stories', en: 'Inspirational Stories and Testimonies', ms: 'Kisah Inspirasi dan Kesaksian' },
        ]),
    }),
    Object.freeze({
        id: 'self-development',
        en: 'Self-Development',
        ms: 'Pembangunan Diri',
        subcategories: Object.freeze([
            { id: 'self-development.motivation', en: 'Motivation', ms: 'Motivasi' },
            { id: 'self-development.productivity', en: 'Productivity', ms: 'Produktiviti' },
            { id: 'self-development.time-management', en: 'Time Management', ms: 'Pengurusan Masa' },
            { id: 'self-development.habit-formation', en: 'Habit Formation', ms: 'Pembentukan Tabiat' },
            { id: 'self-development.emotional-intelligence', en: 'Emotional Intelligence', ms: 'Kecerdasan Emosi' },
            { id: 'self-development.communication-skills', en: 'Communication Skills', ms: 'Kemahiran Komunikasi' },
            { id: 'self-development.self-confidence', en: 'Self-Confidence', ms: 'Keyakinan Diri' },
            { id: 'self-development.strategic-thinking', en: 'Strategic Thinking', ms: 'Pemikiran Strategik' },
            { id: 'self-development.decision-making', en: 'Decision-Making', ms: 'Pembuatan Keputusan' },
            { id: 'self-development.stress-management', en: 'Stress Management', ms: 'Pengurusan Stres' },
            { id: 'self-development.goals-and-achievement', en: 'Goals and Achievement', ms: 'Matlamat dan Pencapaian' },
        ]),
    }),
    Object.freeze({
        id: 'arts-design',
        en: 'Arts and Design',
        ms: 'Seni dan Reka Bentuk',
        subcategories: Object.freeze([
            { id: 'arts-design.fine-arts', en: 'Fine Arts', ms: 'Seni Halus' },
            { id: 'arts-design.drawing-and-painting', en: 'Drawing and Painting', ms: 'Lukisan dan Catan' },
            { id: 'arts-design.photography', en: 'Photography', ms: 'Fotografi' },
            { id: 'arts-design.graphic-design', en: 'Graphic Design', ms: 'Reka Bentuk Grafik' },
            { id: 'arts-design.product-design', en: 'Product Design', ms: 'Reka Bentuk Produk' },
            { id: 'arts-design.digital-art', en: 'Digital Art', ms: 'Seni Digital' },
            { id: 'arts-design.animation', en: 'Animation', ms: 'Animasi' },
            { id: 'arts-design.illustration', en: 'Illustration', ms: 'Ilustrasi' },
            { id: 'arts-design.architecture', en: 'Architecture', ms: 'Seni Bina' },
            { id: 'arts-design.interior-design', en: 'Interior Design', ms: 'Reka Bentuk Dalaman' },
            { id: 'arts-design.fashion', en: 'Fashion', ms: 'Fesyen' },
            { id: 'arts-design.art-history', en: 'Art History', ms: 'Sejarah Seni' },
        ]),
    }),
    Object.freeze({
        id: 'music-performing-arts',
        en: 'Music and Performing Arts',
        ms: 'Muzik dan Seni Persembahan',
        subcategories: Object.freeze([
            { id: 'music-performing-arts.music-theory', en: 'Music Theory', ms: 'Teori Muzik' },
            { id: 'music-performing-arts.composition', en: 'Composition', ms: 'Komposisi' },
            { id: 'music-performing-arts.music-history', en: 'Music History', ms: 'Sejarah Muzik' },
            { id: 'music-performing-arts.musical-instruments', en: 'Musical Instruments', ms: 'Alat Muzik' },
            { id: 'music-performing-arts.singing', en: 'Singing', ms: 'Nyanyian' },
            { id: 'music-performing-arts.theatre', en: 'Theatre', ms: 'Teater' },
            { id: 'music-performing-arts.acting', en: 'Acting', ms: 'Lakonan' },
            { id: 'music-performing-arts.dance', en: 'Dance', ms: 'Tarian' },
            { id: 'music-performing-arts.stage-production', en: 'Stage Production', ms: 'Produksi Pentas' },
            { id: 'music-performing-arts.screenwriting', en: 'Screenwriting', ms: 'Penulisan Skrin' },
            { id: 'music-performing-arts.film-and-cinematography', en: 'Film and Cinematography', ms: 'Filem dan Sinematografi' },
        ]),
    }),
    Object.freeze({
        id: 'sports',
        en: 'Sports and Recreation',
        ms: 'Sukan dan Rekreasi',
        subcategories: Object.freeze([
            { id: 'sports.football', en: 'Football (Soccer)', ms: 'Bola Sepak' },
            { id: 'sports.badminton', en: 'Badminton', ms: 'Badminton' },
            { id: 'sports.basketball', en: 'Basketball', ms: 'Bola Keranjang' },
            { id: 'sports.motorsport', en: 'Motorsport', ms: 'Sukan Motor' },
            { id: 'sports.athletics', en: 'Athletics', ms: 'Olahraga' },
            { id: 'sports.fitness', en: 'Fitness', ms: 'Kecergasan' },
            { id: 'sports.strength-training', en: 'Strength Training', ms: 'Latihan Kekuatan' },
            { id: 'sports.sports-science', en: 'Sports Science', ms: 'Sains Sukan' },
            { id: 'sports.water-sports', en: 'Water Sports', ms: 'Sukan Air' },
            { id: 'sports.outdoor-activities', en: 'Outdoor Activities', ms: 'Aktiviti Luar' },
            { id: 'sports.hiking-and-trekking', en: 'Hiking and Trekking', ms: 'Mendaki dan Trekking' },
            { id: 'sports.coaching-and-strategy', en: 'Coaching and Strategy', ms: 'Kejurulatihan dan Strategi' },
        ]),
    }),
    Object.freeze({
        id: 'food-lifestyle',
        en: 'Food and Lifestyle',
        ms: 'Makanan dan Gaya Hidup',
        subcategories: Object.freeze([
            { id: 'food-lifestyle.malaysian-cuisine', en: 'Malaysian Cuisine', ms: 'Masakan Malaysia' },
            { id: 'food-lifestyle.international-cuisine', en: 'International Cuisine', ms: 'Masakan Antarabangsa' },
            { id: 'food-lifestyle.baking-and-pastry', en: 'Baking and Pastry', ms: 'Pembakerian dan Pastri' },
            { id: 'food-lifestyle.nutrition', en: 'Nutrition', ms: 'Nutrisi' },
            { id: 'food-lifestyle.culinary-arts', en: 'Culinary Arts', ms: 'Seni Kulinari' },
            { id: 'food-lifestyle.beverages', en: 'Beverages', ms: 'Minuman' },
            { id: 'food-lifestyle.meal-planning', en: 'Meal Planning', ms: 'Perancangan Makanan' },
            { id: 'food-lifestyle.home-and-living', en: 'Home and Living', ms: 'Rumah dan Kediaman' },
            { id: 'food-lifestyle.gardening', en: 'Gardening', ms: 'Berkebun' },
            { id: 'food-lifestyle.crafts-and-hobbies', en: 'Crafts and Hobbies', ms: 'Kraf dan Hobi' },
            { id: 'food-lifestyle.fashion-and-lifestyle', en: 'Fashion and Lifestyle', ms: 'Fesyen dan Gaya Hidup' },
        ]),
    }),
    Object.freeze({
        id: 'travel-geography',
        en: 'Travel and Geography',
        ms: 'Pelancongan dan Geografi',
        subcategories: Object.freeze([
            { id: 'travel-geography.travel-guides', en: 'Travel Guides', ms: 'Panduan Pelancongan' },
            { id: 'travel-geography.tourist-destinations', en: 'Tourist Destinations', ms: 'Destinasi Pelancong' },
            { id: 'travel-geography.cultural-tourism', en: 'Cultural Tourism', ms: 'Pelancongan Budaya' },
            { id: 'travel-geography.nature-tourism', en: 'Nature Tourism', ms: 'Pelancongan Alam' },
            { id: 'travel-geography.maps-and-atlases', en: 'Maps and Atlases', ms: 'Peta dan Atlas' },
            { id: 'travel-geography.physical-geography', en: 'Physical Geography', ms: 'Geografi Fizikal' },
            { id: 'travel-geography.geopolitics', en: 'Geopolitics', ms: 'Geopolitik' },
            { id: 'travel-geography.adventure-travel', en: 'Adventure Travel', ms: 'Perjalanan Lasak' },
            { id: 'travel-geography.local-heritage', en: 'Local Heritage', ms: 'Warisan Tempatan' },
            { id: 'travel-geography.country-and-city-guides', en: 'Country and City Guides', ms: 'Panduan Negara dan Bandar' },
        ]),
    }),
    Object.freeze({
        id: 'environment',
        en: 'Environment and Sustainability',
        ms: 'Alam Sekitar dan Kelestarian',
        subcategories: Object.freeze([
            { id: 'environment.climate-change', en: 'Climate Change', ms: 'Perubahan Iklim' },
            { id: 'environment.nature-conservation', en: 'Nature Conservation', ms: 'Pemuliharaan Alam' },
            { id: 'environment.biodiversity', en: 'Biodiversity', ms: 'Kepelbagaian Biologi' },
            { id: 'environment.ecology', en: 'Ecology', ms: 'Ekologi' },
            { id: 'environment.renewable-energy', en: 'Renewable Energy', ms: 'Tenaga Boleh Baharu' },
            { id: 'environment.waste-management', en: 'Waste Management', ms: 'Pengurusan Sisa' },
            { id: 'environment.sustainable-development', en: 'Sustainable Development', ms: 'Pembangunan Lestari' },
            { id: 'environment.sustainable-agriculture', en: 'Sustainable Agriculture', ms: 'Pertanian Lestari' },
            { id: 'environment.green-economy', en: 'Green Economy', ms: 'Ekonomi Hijau' },
            { id: 'environment.water-resources', en: 'Water Resources', ms: 'Sumber Air' },
        ]),
    }),
    Object.freeze({
        id: 'agriculture',
        en: 'Agriculture and Natural Resources',
        ms: 'Pertanian dan Sumber Asli',
        subcategories: Object.freeze([
            { id: 'agriculture.agronomy', en: 'Agronomy', ms: 'Agronomi' },
            { id: 'agriculture.horticulture', en: 'Horticulture', ms: 'Hortikultur' },
            { id: 'agriculture.modern-agriculture', en: 'Modern Agriculture', ms: 'Pertanian Moden' },
            { id: 'agriculture.organic-farming', en: 'Organic Farming', ms: 'Pertanian Organik' },
            { id: 'agriculture.aquaculture', en: 'Aquaculture', ms: 'Akuakultur' },
            { id: 'agriculture.forestry', en: 'Forestry', ms: 'Perhutanan' },
            { id: 'agriculture.animal-husbandry', en: 'Animal Husbandry', ms: 'Penternakan' },
            { id: 'agriculture.soil-science', en: 'Soil Science', ms: 'Sains Tanah' },
            { id: 'agriculture.agricultural-technology', en: 'Agricultural Technology', ms: 'Teknologi Pertanian' },
            { id: 'agriculture.natural-resource-management', en: 'Natural Resource Management', ms: 'Pengurusan Sumber Asli' },
        ]),
    }),
    Object.freeze({
        id: 'reference',
        en: 'Reference and General Knowledge',
        ms: 'Rujukan dan Pengetahuan Umum',
        subcategories: Object.freeze([
            { id: 'reference.encyclopedias', en: 'Encyclopedias', ms: 'Ensiklopedia' },
            { id: 'reference.dictionaries', en: 'Dictionaries', ms: 'Kamus' },
            { id: 'reference.thesauruses', en: 'Thesauruses', ms: 'Tesaurus' },
            { id: 'reference.atlases', en: 'Atlases', ms: 'Atlas' },
            { id: 'reference.almanacs', en: 'Almanacs', ms: 'Almanak' },
            { id: 'reference.directories', en: 'Directories', ms: 'Direktori' },
            { id: 'reference.fact-books', en: 'Fact Books', ms: 'Buku Fakta' },
            { id: 'reference.guides', en: 'Guides', ms: 'Panduan' },
            { id: 'reference.manuals', en: 'Manuals', ms: 'Manual' },
            { id: 'reference.glossaries', en: 'Glossaries', ms: 'Glosari' },
            { id: 'reference.statistical-reference', en: 'Statistical Reference Books', ms: 'Buku Rujukan Statistik' },
            { id: 'reference.questions-and-answers', en: 'Questions and Answers (Q&A)', ms: 'Soal Jawab (Q&A)' },
        ]),
    }),
    Object.freeze({
        id: 'comics',
        en: 'Comics, Manga and Graphic Novels',
        ms: 'Komik, Manga dan Novel Grafik',
        subcategories: Object.freeze([
            { id: 'comics.western-comics', en: 'Western Comics', ms: 'Komik Barat' },
            { id: 'comics.japanese-manga', en: 'Japanese Manga', ms: 'Manga Jepun' },
            { id: 'comics.korean-manhwa', en: 'Korean Manhwa', ms: 'Manhwa Korea' },
            { id: 'comics.chinese-manhua', en: 'Chinese Manhua', ms: 'Manhua Cina' },
            { id: 'comics.graphic-novels', en: 'Graphic Novels', ms: 'Novel Grafik' },
            { id: 'comics.webtoons', en: 'Webtoons', ms: 'Webtoon' },
            { id: 'comics.superhero-comics', en: 'Superhero Comics', ms: 'Komik Wira Super' },
            { id: 'comics.adventure-comics', en: 'Adventure Comics', ms: 'Komik Petualangan' },
            { id: 'comics.horror-comics', en: 'Horror Comics', ms: 'Komik Seram' },
            { id: 'comics.educational-comics', en: 'Educational Comics', ms: 'Komik Pendidikan' },
            { id: 'comics.biographical-comics', en: 'Biographical Comics', ms: 'Komik Biografi' },
        ]),
    }),
    Object.freeze({
        id: 'career',
        en: 'Career and Professional Skills',
        ms: 'Kerjaya dan Kemahiran Profesional',
        subcategories: Object.freeze([
            { id: 'career.career-development', en: 'Career Development', ms: 'Pembangunan Kerjaya' },
            { id: 'career.resumes-and-interviews', en: 'Resumes and Job Interviews', ms: 'Resume dan Temuduga Kerja' },
            { id: 'career.workplace-skills', en: 'Workplace Skills', ms: 'Kemahiran Tempat Kerja' },
            { id: 'career.professional-communication', en: 'Professional Communication', ms: 'Komunikasi Profesional' },
            { id: 'career.team-management', en: 'Team Management', ms: 'Pengurusan Pasukan' },
            { id: 'career.organisational-leadership', en: 'Organisational Leadership', ms: 'Kepimpinan Organisasi' },
            { id: 'career.technical-skills', en: 'Technical Skills', ms: 'Kemahiran Teknikal' },
            { id: 'career.professional-certifications', en: 'Professional Certifications', ms: 'Pensijilan Profesional' },
            { id: 'career.freelancing', en: 'Freelancing', ms: 'Kerja Bebas' },
            { id: 'career.digital-careers', en: 'Digital Careers', ms: 'Kerjaya Digital' },
        ]),
    }),
    Object.freeze({
        id: 'politics',
        en: 'Politics and International Relations',
        ms: 'Politik dan Hubungan Antarabangsa',
        subcategories: Object.freeze([
            { id: 'politics.political-theory', en: 'Political Theory', ms: 'Teori Politik' },
            { id: 'politics.systems-of-government', en: 'Systems of Government', ms: 'Sistem Pemerintahan' },
            { id: 'politics.democracy', en: 'Democracy', ms: 'Demokrasi' },
            { id: 'politics.public-policy', en: 'Public Policy', ms: 'Dasar Awam' },
            { id: 'politics.diplomacy', en: 'Diplomacy', ms: 'Diplomasi' },
            { id: 'politics.geopolitical-strategy', en: 'Geopolitical Strategy', ms: 'Strategi Geopolitik' },
            { id: 'politics.international-security', en: 'International Security', ms: 'Keselamatan Antarabangsa' },
            { id: 'politics.conflict-and-peace', en: 'Conflict and Peace', ms: 'Konflik dan Damai' },
            { id: 'politics.elections', en: 'Elections', ms: 'Pilihan Raya' },
            { id: 'politics.public-administration', en: 'Public Administration', ms: 'Pentadbiran Awam' },
        ]),
    }),
    Object.freeze({
        id: 'military',
        en: 'Military and Security Studies',
        ms: 'Ketenteraan dan Kajian Keselamatan',
        subcategories: Object.freeze([
            { id: 'military.military-history', en: 'Military History', ms: 'Sejarah Tentera' },
            { id: 'military.strategy-and-doctrine', en: 'Strategy and Doctrine', ms: 'Strategi dan Doktrin' },
            { id: 'military.defence-studies', en: 'Defence Studies', ms: 'Kajian Pertahanan' },
            { id: 'military.national-security', en: 'National Security', ms: 'Keselamatan Negara' },
            { id: 'military.conflict-studies', en: 'Conflict Studies', ms: 'Kajian Konflik' },
            { id: 'military.crisis-management', en: 'Crisis Management', ms: 'Pengurusan Krisis' },
            { id: 'military.maritime-security', en: 'Maritime Security', ms: 'Keselamatan Maritim' },
            { id: 'military.cybersecurity', en: 'Cybersecurity', ms: 'Keselamatan Siber' },
            { id: 'military.international-peacekeeping', en: 'International Peacekeeping', ms: 'Pengamanan Antarabangsa' },
        ]),
    }),
    Object.freeze({
        id: 'media',
        en: 'Communication and Media',
        ms: 'Komunikasi dan Media',
        subcategories: Object.freeze([
            { id: 'media.journalism', en: 'Journalism', ms: 'Kewartawanan' },
            { id: 'media.mass-communication', en: 'Mass Communication', ms: 'Komunikasi Massa' },
            { id: 'media.public-relations', en: 'Public Relations', ms: 'Hubungan Awam' },
            { id: 'media.advertising', en: 'Advertising', ms: 'Pengiklanan' },
            { id: 'media.digital-media', en: 'Digital Media', ms: 'Media Digital' },
            { id: 'media.social-media', en: 'Social Media', ms: 'Media Sosial' },
            { id: 'media.broadcasting', en: 'Broadcasting', ms: 'Penyiaran' },
            { id: 'media.corporate-communication', en: 'Corporate Communication', ms: 'Komunikasi Korporat' },
            { id: 'media.media-studies', en: 'Media Studies', ms: 'Kajian Media' },
            { id: 'media.media-literacy', en: 'Media Literacy', ms: 'Literasi Media' },
        ]),
    }),
    Object.freeze({
        id: 'workbooks',
        en: 'Workbooks and Learning Materials',
        ms: 'Buku Kerja dan Bahan Pembelajaran',
        subcategories: Object.freeze([
            { id: 'workbooks.exercise-books', en: 'Exercise Books', ms: 'Buku Latihan' },
            { id: 'workbooks.activity-books', en: 'Activity Books', ms: 'Buku Aktiviti' },
            { id: 'workbooks.worksheets', en: 'Worksheets', ms: 'Lembaran Kerja' },
            { id: 'workbooks.examination-questions', en: 'Examination Questions', ms: 'Soalan Peperiksaan' },
            { id: 'workbooks.question-banks', en: 'Question Banks', ms: 'Bank Soalan' },
            { id: 'workbooks.revision-guides', en: 'Revision Guides', ms: 'Panduan Ulangan' },
            { id: 'workbooks.problem-solving-workbooks', en: 'Problem-Solving Workbooks', ms: 'Buku Kerja Penyelesaian Masalah' },
            { id: 'workbooks.tutorials', en: 'Tutorials', ms: 'Tutorial' },
            { id: 'workbooks.learning-modules', en: 'Learning Modules', ms: 'Modul Pembelajaran' },
            { id: 'workbooks.examination-preparation', en: 'Examination Preparation Books', ms: 'Buku Persediaan Peperiksaan' },
        ]),
    }),
    Object.freeze({
        id: 'alamtologi',
        en: 'Alamtologi',
        ms: 'Alamtologi',
        subcategories: Object.freeze([
            { id: 'alamtologi.foundations', en: 'Alamtologi Foundations', ms: 'Asas Alamtologi' },
        ]),
    }),
]);
//# sourceMappingURL=qx-taxonomy-data-b.js.map